import React from "react";
import { FaChevronRight, FaLock, FaUserEdit } from "react-icons/fa";
import SocialPlatformIcon from "../../../../components/SocialPlatformIcon";
import { OpenLink, SetupStatus, StatusDot, fmtShort, isOpen, ownerLabel, stepSummary } from "./setupUi";

function SetupStepRow({ step, onOpen, isStaff = true }) {
  const waiting = isOpen(step) && step.Waiting_For?.length ? step.Waiting_For : null;
  const sub = waiting
    ? `Waits for: ${waiting.join(", ")}`
    : step.Status === "Blocked" && step.Blocked_Reason
      ? step.Blocked_Reason
      : stepSummary(step) || step.Description;
  const clientInput = step.Client_Notes && step.Owner === "Client" && isOpen(step);
  const social = step.Social_Match;
  const fillable = Object.keys(social?.Suggested || {}).length;

  return (
    <div className={`dms-row${waiting ? " is-waiting" : ""}${step.Status === "Not Applicable" ? " is-na" : ""}`}>
      <button type="button" className="dms-row__btn" onClick={() => onOpen(step.Tenant_Step_Id)}>
        <StatusDot status={step.Status} />
        <span className="dms-row__main">
          <span className="dms-row__title">
            {step.Title}
            {step.Is_Optional ? <span className="dms-tag">optional</span> : null}
            {clientInput ? (
              <span
                className="dms-tag dms-tag--input"
                title={isStaff ? "See what we need from the client" : "See what we need from you"}
              >
                <FaUserEdit aria-hidden="true" /> {isStaff ? "client input" : "your input"}
              </span>
            ) : null}
            {social?.Account ? (
              <span className="dms-tag dms-tag--social" title={`Linked Social Account: ${social.Account.Account_Name}`}>
                <SocialPlatformIcon platform={social.Account.Platform_Name} size={11} /> {social.Account.Account_Name}
              </span>
            ) : null}
            {fillable ? (
              <span className="dms-tag dms-tag--fill" title="Values found in Social Accounts; open the step to use them">
                {fillable} to fill
              </span>
            ) : null}
            {waiting ? <FaLock className="dms-row__lock" aria-label="Waiting for an earlier step" /> : null}
          </span>
          {sub ? <span className={`dms-row__sub${step.Status === "Blocked" ? " is-alert" : ""}`}>{sub}</span> : null}
        </span>
        <span className="dms-row__meta">
          {step.Due_Date ? (
            <span className={`dms-row__due${step.Overdue ? " is-late" : ""}`}>
              {step.Overdue ? "Overdue " : "Due "}
              {fmtShort(step.Due_Date)}
            </span>
          ) : null}
          {step.Assigned_To_Name ? <span className="dmp-muted">{step.Assigned_To_Name}</span> : null}
        </span>
        <span className={`dms-owner dms-owner--${step.Owner.toLowerCase()}`}>{ownerLabel(step.Owner)}</span>
        <SetupStatus status={step.Status} small />
        <FaChevronRight className="dms-row__go" aria-hidden="true" />
      </button>
      <span className="dms-row__link">
        {isStaff || step.Owner !== "Agency" ? (
          <OpenLink href={step.Open_Url} title={`Open ${step.Title} in a new window`} chip />
        ) : null}
      </span>
    </div>
  );
}

export default SetupStepRow;
